import type { ServerModal } from "@/features/server-modals/models";
import { serverModalSchema } from "@/features/server-modals/models";
import { parseResponseData, privateAPI } from "@/shared/lib";

export const getServerModals = async () => {
  const response = await privateAPI.get("/popups");

  return parseResponseData(response, serverModalSchema.array());
};

export const markServerModalAsViewed = async (ids: ServerModal["id"][]) => {
  return await privateAPI.post("/popups/viewed", {
    popups: ids,
  });
};
